<template>
	<div class="stage-statistics-wrapper" :type="type">
		<div class="stage-statistics">
			<div class="stage-name">
				{{ name }}
			</div>
			<div v-if="statusText && statusText !== ''" class="stage-status-text">
				{{ statusText }}
			</div>
		</div>
		<div class="stage-number">
			{{ number }}
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "StageStatistics",
	props: {
		/**
		 * Name of stage
		 */
		name: {
			type: String,
			required: true
		},

		/**
		 * Status text of Stage
		 */
		statusText: {
			type: String,
			required: true
		},
		/**
		 * Number of stage
		 */
		number: {
			type: String,
			required: true
		},
		/**
		 * 'success' | 'error' | 'inProgress' | 'warning' | 'disabled' | 'standby' | 'paused'
		 */

		type: {
			type: String,
			default: "inProgress",
			validator(value) {
				return [
					"success",
					"error",
					"inProgress",
					"warning",
					"disabled",
					"standby",
					"paused"
				].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
$stage-status-text-color: var(--dashboard-font-dark);
$disabled-color: var(--dashboard-font-light);
$stage-type-colors: (
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"inProgress": var(--dashboard-primary),
	"disabled": var(--dashboard-font-light),
	"standby": var(--dashboard-font-light),
	"paused": var(--dashboard-font-light)
);

.stage-statistics-wrapper {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-direction: row;

	.stage-statistics {
		display: flex;
		flex-direction: column;
		// justify-content: flex-start;
		// gap: 8px;
		max-width: calc(100% - 48px);

		> * {
			margin: 4px 0px 4px 0px;
		}

		> :first-child {
			margin: 0px 0px 4px 0px;
		}

		> :last-child {
			margin: 4px 0px 0px 0px;
		}

		> :only-child {
			margin: 0px !important;
		}

		.stage-name {
			font-size: 18px;
			line-height: 18px;
			text-transform: uppercase;
			font-weight: 600;
			word-break: break-all;
		}

		.stage-status-text {
			font-size: 14px;
			line-height: 14px;
			color: $stage-status-text-color;
			font-weight: 300;
		}
	}

	.stage-number {
		font: Bold 64px/48px var(--number-font);

		opacity: 0.5;
	}

	@each $type, $color in $stage-type-colors {
		&[type="#{$type}"] {
			> .stage-statistics > .stage-name {
				color: $color;
			}

			> .stage-number {
				color: $color;
			}
		}

		@if $type == "disabled" or $type == "standby" or $type == "paused" {
			&[type="#{$type}"] {
				> .stage-statistics > .stage-status-text {
					color: $color !important;
				}
			}
		}
	}
}
</style>
